import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Transition } from 'react-transition-group';
import { apiCreatePopupRead, popupRfpReplaceHideAction, } from '@/actions/PopupActions';
import { CLIENT_RFP_REPLACE_PDF_URL, PROFESSIONAL_RFP_REPLACE_V2_PDF_URL, } from '@/define/consts/assets';
import { propStr, propBool } from '@/helpers/custom-prop-types';
import { POPUP_TYPE_CLIENT_RFP_REPLACE, POPUP_TYPE_PROFESSIONAL_RFP_REPLACE_V2, } from '@/utils/constants/popup/eventType';
import { isClient } from '@/utils/resources/auth/authResource';
/**
 * TODO: 後でTS化・tailwind化、またクライアント側と共通で参照できるディレクトリに配置すること
 */
const RfpReplacePopup = (props) => {
    const { className, isHidden } = props;
    const dispatch = useDispatch();
    const auth = useSelector((state) => state.auth);
    const profile = useSelector((state) => state.profile);
    const hideRfpReplace = useSelector((state) => state.popup.hideRfpReplace);
    // ユーザーがクライアントか
    const isClientUser = isClient(auth);
    // イベント種別
    const event = isClientUser
        ? POPUP_TYPE_CLIENT_RFP_REPLACE
        : POPUP_TYPE_PROFESSIONAL_RFP_REPLACE_V2;
    const isShow = useMemo(() => {
        if (hideRfpReplace) {
            return false;
        }
        const { viewPopups } = profile || {};
        return (viewPopups || []).includes(event);
    }, [event, profile, hideRfpReplace]);
    const onClickClose = useCallback(() => {
        dispatch(popupRfpReplaceHideAction());
    }, [dispatch]);
    const onClickNoViewMore = useCallback(() => {
        dispatch(popupRfpReplaceHideAction());
        dispatch(apiCreatePopupRead(event));
    }, [event, dispatch]);
    if (isHidden) {
        return null;
    }
    return (_jsx(Transition, Object.assign({ in: isShow, mountOnEnter: true, timeout: 500, unmountOnExit: true }, { children: (state) => (_jsx("div", Object.assign({ className: `footer_popup_rfp_replace ${state} ${className}` }, { children: _jsxs("div", Object.assign({ className: 'footer_popup_rfp_replace_container' }, { children: [_jsxs("div", Object.assign({ className: 'footer_popup_rfp_replace_title' }, { children: ["PROFFIT\u304B\u3089\u91CD\u8981\u306A\u304A\u77E5\u3089\u305B", _jsx("button", Object.assign({ className: 'close_button', onClick: onClickClose, type: 'button' }, { children: _jsx("i", { className: 'material-icons close_icon' }) }))] })), _jsxs("div", Object.assign({ className: 'footer_popup_rfp_replace_body' }, { children: [_jsxs("div", Object.assign({ className: 'footer_popup_rfp_replace_body_head' }, { children: [_jsx("i", { className: 'material-icons error error-icon' }), _jsx("div", { children: isClientUser ? (_jsxs(_Fragment, { children: ["\u63D0\u6848\u52DF\u96C6\u306E\u6A5F\u80FD\u304C\u8FFD\u52A0\u3055\u308C\u307E\u3057\u305F\u3002", _jsx("br", {}), "\u5909\u66F4\u70B9\u306B\u3064\u3044\u3066\u3001\u5FC5\u305A\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002"] })) : (_jsxs(_Fragment, { children: ["\u63D0\u6848\u6A5F\u80FD\u3068\u6599\u91D1\u30D7\u30E9\u30F3\u304C\u5909\u66F4\u3055\u308C\u307E\u3057\u305F\u3002", _jsx("br", {}), "\u5909\u66F4\u70B9\u306B\u3064\u3044\u3066\u3001\u5FC5\u305A\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002"] })) })] })), _jsx("div", Object.assign({ className: 'footer_popup_rfp_replace_body_download' }, { children: _jsx("a", Object.assign({ className: 'button primary download_button', href: isClientUser
                                        ? CLIENT_RFP_REPLACE_PDF_URL
                                        : PROFESSIONAL_RFP_REPLACE_V2_PDF_URL, rel: 'noopener noreferrer', target: '_blank' }, { children: "\u8CC7\u6599\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3059\u308B" })) })), _jsx("div", Object.assign({ className: 'footer_popup_rfp_replace_body_hide' }, { children: _jsx("button", Object.assign({ className: 'link-text hide_button', onClick: onClickNoViewMore, type: 'button' }, { children: "\u4ECA\u5F8C\u8868\u793A\u3057\u306A\u3044" })) }))] }))] })) }))) })));
};
RfpReplacePopup.propTypes = {
    className: propStr(),
    isHidden: propBool(),
};
RfpReplacePopup.defaultProps = {
    className: '',
    // ポップアップが必要になったらfalseに切り替えておく
    isHidden: true,
};
export default RfpReplacePopup;
